import { BusinessPolicy, createDefaultBusinessPolicy } from '../../business/models/policy-business.model';
import { ApplicationState } from '..';
import { SvsViews } from '../details/svs/model';
import { RimViews } from '../details/rim/model';

// Map application store to policy business model
// Put all data needed for validation here
export function mapStateToPolicyBusiness(state: ApplicationState): BusinessPolicy {
    const result: BusinessPolicy = createDefaultBusinessPolicy();

    result.id = Number(state.details.detailsPolicy.policy.damageCaseCode);
    result.legalExcessAmount = state.details.detailsPolicy.policy.legalExcessAmount;
    result.excessAmount = state.details.detailsPolicy.policy.excessAmountBuilding || state.details.detailsPolicy.policy.excessAmountContent;
    result.raisedExcessAmount = state.details.detailsPolicy.policy.raisedExcessAmountBuilding || state.details.detailsPolicy.policy.raisedExcessAmountContent;
    result.loweredExcessAmountThreshold = state.details.detailsPolicy.policy.loweredExcessAmountThreshold;
    result.indirectLossesPercentage = state.details.detailsPolicy.policy.indirectLossesPercentage;
    result.indirectLossesBuilding = state.details.detailsPolicy.policy.indirectLossesBuilding;
    result.indirectLossesContent = state.details.detailsPolicy.policy.indirectLossesContent;
    result.guaranteeTCContent = state.details.detailsPolicy.policy.guaranteeTCContent;
    result.conditions = state.details.detailsPolicy.policy.conditions;
    result.policySubTypeTC = state.details.detailsPolicy.policy.policySubTypeTC;
    result.policyHolderLanguageTC = state.details.detailsInsuredPerson.languageTC;
    result.Svs.svsLines = state.details.detailsSvs.lines.map((item: any) => item);
    result.Svs.excessApplicableTCchecked = state.details.detailsSvs.excessApplicableTC ? true : false;
    result.Svs.underConditionTCchecked = state.details.detailsSvs.underConditionTC ? true : false;
    result.Svs.damageCauseRemark = state.details.detailsSvs.valueAndCause.damageCauseRemark;
    result.Svs.currentLine.description = state.details.detailsSvs.currentLine.description;
    result.Svs.currentLine.amount = +state.details.detailsSvs.currentLine.amount;
    result.Svs.iban = state.details.detailsSvs.vatAndPayment.iban;
    result.Svs.financialAccountNumber = state.details.detailsSvs.vatAndPayment.financialAccountNumber;
    result.Svs.sendEmailToPolicyHolder = state.details.detailsSvs.communication.sendEmailToPolicyHolder;
    result.Svs.emailPolicyHolder = state.details.detailsSvs.communication.emailPolicyHolder;
    result.Svs.sendEmailToCounterExpert = state.details.detailsSvs.communication.sendEmailToCounterExpert;
    result.Svs.emailCounterExpert = state.details.detailsSvs.communication.emailCounterExpert;
    result.Svs.sendEmailToPersonalExpert = state.details.detailsSvs.communication.sendEmailToPersonalExpert;
    result.Svs.emailPersonalExpert = state.details.detailsSvs.communication.emailPersonalExpert;
    result.Svs.sendEmailToOther = state.details.detailsSvs.communication.sendEmailToOther;
    result.Svs.emailOther = state.details.detailsSvs.communication.emailOther;

    result.Rim.bban = state.details.detailsRim.vatAndPayment.bban;
    result.Rim.bicCode = state.details.detailsRim.vatAndPayment.bicCode;
    result.Rim.iban = state.details.detailsRim.vatAndPayment.iban;
    result.Rim.deductibleVatPercentage = state.details.detailsRim.vatAndPayment.deductibleVatPercentage;
    result.Rim.vat21ToBeJustifiedAmount = state.details.detailsRim.vatAndPayment.vat21ToBeJustifiedAmount;
    result.Rim.vat6ToBeJustifiedAmount = state.details.detailsRim.vatAndPayment.vat6ToBeJustifiedAmount;
    result.Rim.rimLines = (state.details.detailsRim.rimLines
        ? state.details.detailsRim.rimLines.map(rimLine => ({
            ...rimLine, 
          }))
        : []);
    result.Rim.rimLinesAmountTotal = state.details.detailsRim.rimLinesAmountTotal;
    result.Rim.rimLinesAmount80Total = state.details.detailsRim.rimLinesAmount80Total;
    result.Rim.currentRimLine = { ...state.details.detailsRim.currentRimLine };
    result.Rim.rimItemValues = state.details.detailsRim.rimTypeCodes.rimItemValues;
    result.Rim.rimSectionValues = state.details.detailsRim.rimTypeCodes.rimSectionValues;
    result.Rim.vatThresholdValues = state.details.detailsRim.rimTypeCodes.vatThresholdValues;
    result.Rim.damageCauseRemark = state.details.detailsRim.valueAndCause.damageCauseRemark;
    result.Rim.paidByBankTransfer = state.details.detailsRim.vatAndPayment.paidByBankTransfer;
    result.Rim.sendEmailToPolicyHolder = state.details.detailsRim.communication.sendEmailToPolicyHolder;
    result.Rim.emailPolicyHolder = state.details.detailsRim.communication.emailPolicyHolder;
    result.Rim.sendEmailToCounterExpert = state.details.detailsRim.communication.sendEmailToCounterExpert;
    result.Rim.emailCounterExpert = state.details.detailsRim.communication.emailCounterExpert;
    result.Rim.sendEmailToPersonalExpert = state.details.detailsRim.communication.sendEmailToPersonalExpert;
    result.Rim.emailPersonalExpert = state.details.detailsRim.communication.emailPersonalExpert;
    result.Rim.sendEmailToOther = state.details.detailsRim.communication.sendEmailToOther;
    result.Rim.emailOther = state.details.detailsRim.communication.emailOther;

    return result;
}

export function mapSvsStateToPolicyBusiness(state: ApplicationState, id: number): BusinessPolicy {
    const result: BusinessPolicy = createDefaultBusinessPolicy();

    result.legalExcessAmount = state.details.detailsPolicy.policy.legalExcessAmount;
    result.loweredExcessAmountThreshold = state.details.detailsPolicy.policy.loweredExcessAmountThreshold;
    result.indirectLossesPercentage = state.details.detailsPolicy.policy.indirectLossesPercentage;
    result.indirectLossesBuilding = state.details.detailsPolicy.policy.indirectLossesBuilding;
    result.indirectLossesContent = state.details.detailsPolicy.policy.indirectLossesContent;

    const svs = state.details.detailsSvs.svsItems.filter(item => item.id === id)[0].svsData;

    result.Svs.id = id;
    result.Svs.svsLines = svs.lines.map((item: any) => item);
    result.Svs.excessApplicableTCchecked = svs.excessApplicableTC !== undefined;
    result.Svs.underConditionTCchecked = svs.underConditionTC !== undefined;
    result.Svs.damageCauseRemark = svs.valueAndCause.damageCauseRemark === null ? '' : svs.valueAndCause.damageCauseRemark;
    result.Svs.currentLine.description = '';
    result.Svs.currentLine.amount = 0;
    result.Svs.iban = svs.vatAndPayment.iban;

    result.Svs.sendEmailToPolicyHolder = svs.communication.sendEmailToPolicyHolder;
    result.Svs.emailPolicyHolder = svs.communication.emailPolicyHolder;
    result.Svs.sendEmailToCounterExpert = svs.communication.sendEmailToCounterExpert;
    result.Svs.emailCounterExpert = svs.communication.emailCounterExpert;
    result.Svs.sendEmailToPersonalExpert = svs.communication.sendEmailToPersonalExpert;
    result.Svs.emailPersonalExpert = svs.communication.emailPersonalExpert;
    result.Svs.sendEmailToOther = svs.communication.sendEmailToOther;
    result.Svs.emailOther = svs.communication.emailOther;

    return result;
}

export function mapRimStateToPolicyBusiness(state: ApplicationState, id: number): BusinessPolicy {
    const result: BusinessPolicy = createDefaultBusinessPolicy();

    result.legalExcessAmount = state.details.detailsPolicy.policy.legalExcessAmount;
    result.loweredExcessAmountThreshold = state.details.detailsPolicy.policy.loweredExcessAmountThreshold;
    result.indirectLossesPercentage = state.details.detailsPolicy.policy.indirectLossesPercentage;
    result.indirectLossesBuilding = state.details.detailsPolicy.policy.indirectLossesBuilding;
    result.indirectLossesContent = state.details.detailsPolicy.policy.indirectLossesContent;
    result.id = Number(state.details.detailsPolicy.policy.damageCaseCode);

    const rim = state.details.detailsRim.rimsTotal.filter(item => item.rimHeaderId === id)[0].rimData;

    result.Rim.id = rim.rimHeaderId;
    result.Rim.damageCauseRemark = rim.damageCauseRemark;
    result.Rim.bban = rim.bban;
    result.Rim.iban = rim.iban;
    result.Rim.paidByBankTransfer = rim.paidByBankTransfer;
    result.Rim.rimLines = rim.rimLines.map(rimLine => ({
        ...rimLine
    }));
    result.Rim.sendEmailToPolicyHolder = rim.sendEmailToPolicyHolder;
    result.Rim.emailPolicyHolder = rim.emailPolicyHolder;
    result.Rim.sendEmailToCounterExpert = rim.sendEmailToCounterExpert;
    result.Rim.emailCounterExpert = rim.emailCounterExpert;
    result.Rim.sendEmailToPersonalExpert = rim.sendEmailToPersonalExpert;
    result.Rim.emailPersonalExpert = rim.emailPersonalExpert;
    result.Rim.sendEmailToOther = rim.sendEmailToOther;
    result.Rim.emailOther = rim.emailOther;
    result.Rim.rimStatusTC = rim.rimStatusTC;

    return result;
}

export function svsCurrentView(state: ApplicationState): SvsViews { return state.details.detailsSvs.currentView; }

export function rimCurrentView(state: ApplicationState): RimViews { return state.details.detailsRim.currentView; }
